"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildDefaultSpotlightCurrentVenueConfig = buildDefaultSpotlightCurrentVenueConfig;
exports.parseSpotlightCurrentVenue = parseSpotlightCurrentVenue;
exports.validateSpotlightCurrentVenueForSave = validateSpotlightCurrentVenueForSave;
function buildDefaultSpotlightCurrentVenueConfig() {
  return {
    alwaysInclude: true,
    pinFirst: true
  };
}
function parseSpotlightCurrentVenue(raw) {
  const defaults = buildDefaultSpotlightCurrentVenueConfig();
  if (!raw || typeof raw !== 'object') {
    return defaults;
  }
  const value = raw;
  return {
    alwaysInclude: typeof value.alwaysInclude === 'boolean' ? value.alwaysInclude : defaults.alwaysInclude,
    pinFirst: typeof value.pinFirst === 'boolean' ? value.pinFirst : defaults.pinFirst
  };
}
function validateSpotlightCurrentVenueForSave(value) {
  if (!value || typeof value !== 'object') {
    return {
      message: 'spotlightCurrentVenue must be an object.'
    };
  }
  const config = value;
  if (typeof config.alwaysInclude !== 'boolean') {
    return {
      message: 'spotlightCurrentVenue.alwaysInclude must be a boolean.'
    };
  }
  if (typeof config.pinFirst !== 'boolean') {
    return {
      message: 'spotlightCurrentVenue.pinFirst must be a boolean.'
    };
  }
  return null;
}
//# sourceMappingURL=spotlight-current-venue-config.js.map